export default __webpack_public_path__ + "./images/noPhoto40.ebf36b9d.svg";